import { RefreshCw } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';

import RhbIcon from '@/assets/icons/rhb-logo.svg?react';
import RhbTopNavBg from '@/assets/images/navbar-cutout.svg?react';
import BurgerMenu from '@/components/shared/burger-menu';
import MenuItems from '@/components/top-nav/menu-items';
import { Button } from '@/components/ui/button';
import {
  SEARCH_PARAM_DRAWER,
  SEARCH_PARAM_LOCK_PIN,
  SEARCH_PARAM_LOCK_PIN_TYPE,
} from '@/utils/constants/queries';

interface TopNavProps {
  visibility?: boolean;
}

const TopNav = ({ visibility = true }: TopNavProps) => {
  const { t } = useTranslation();
  const location = useLocation();

  const { VITE_APP_ENV } = import.meta.env;

  const currentSearchParams = new URLSearchParams(location.search);
  const persistentParams = new URLSearchParams();

  const paramsToPersist = [SEARCH_PARAM_LOCK_PIN, SEARCH_PARAM_LOCK_PIN_TYPE, SEARCH_PARAM_DRAWER];

  paramsToPersist.forEach((param) => {
    if (currentSearchParams.has(param)) {
      persistentParams.set(param, currentSearchParams.get(param) as string);
    }
  });

  const hasLockPin = currentSearchParams.has(SEARCH_PARAM_LOCK_PIN);
  const hasLockPinType = currentSearchParams.has(SEARCH_PARAM_LOCK_PIN_TYPE);

  if (hasLockPin && hasLockPinType && !currentSearchParams.has(SEARCH_PARAM_DRAWER)) {
    persistentParams.set(SEARCH_PARAM_DRAWER, 'true');
  }

  const queryString = persistentParams.toString();
  const persistentSearch = queryString ? `?${queryString}` : '';

  const onHandleRefresh = () => {
    window.location.reload();
  };

  return (
    <header className="fixed top-0 left-0 w-full h-16 z-50 flex">
      <div className="absolute top-0 left-0 w-full flex justify-between items-center h-full pl-5 pr-8">
        <Link
          to={`/home${persistentSearch}`}
          className="cursor-pointer"
          role="link"
          aria-label="link-home"
        >
          <RhbIcon />
        </Link>
        <div className="flex gap-2">
          {VITE_APP_ENV === 'staging' && (
            <Button className="rounded-full pointer-events-none w-22">Beta</Button>
          )}
          {visibility && (
            <div className="flex gap-4 items-center">
              <RefreshCw
                className="size-6 cursor-pointer text-background"
                strokeWidth={2.5}
                onClick={onHandleRefresh}
              />
              <BurgerMenu header={t('menu.header')}>
                <MenuItems persistentSearch={persistentSearch} />
              </BurgerMenu>
            </div>
          )}
        </div>
      </div>
      <div className="bg-primary flex-1" />
      <RhbTopNavBg />
    </header>
  );
};

export default TopNav;
